import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { APP_ROUTING_NAMES } from '../app.routes.names';
import { ISupplementRequest } from '../model/supplement/isupplement-request';
import { APPLICANT_NAMES, ATTACHMENT_NAMES } from '../service/ansokan-form-builder/application-names';
import { CustomValidators } from '../service/ansokan-form-builder/custom-validators';
import { SUPPLEMENT_FORM_DEF } from '../service/ansokan-form-builder/form-definitions';
import { getErrorText } from '../service/ansokan-form-builder/validator-errors';
import { AnsokanFormGroupService } from '../service/ansokan-form-group/ansokan-form-group.service';
import { SupplementService } from '../service/supplement/supplement.service';

@Component({
    selector: 'app-supplement',
    styleUrls: ['./supplement.component.scss'],
    templateUrl: './supplement.component.html',
    standalone: false
})
export class SupplementComponent implements OnInit {

  private submitting: boolean;
  private submitted: boolean;
  private error: boolean;

  public get isSubmitting(): boolean {
    return this.submitting;
  }

  public get isSubmitted(): boolean {
    return this.submitted;
  }

  public get hasError(): boolean {
    return this.error;
  }

  public get email(): UntypedFormControl {
    return this.groupService.getFormGroup().get(APPLICANT_NAMES.EMAIL) as UntypedFormControl;
  }

  public get applicantSsn(): UntypedFormControl {
    return this.groupService.getFormGroup().get('applicantSsn') as UntypedFormControl;
  }

  public get applicantText(): UntypedFormControl {
    return this.groupService.getFormGroup().get('applicantText') as UntypedFormControl;
  }

  public get formValid(): boolean {
    return this.groupService.valid;
  }

  public get attachmentsInvalid(): boolean {
    return !this.attachmentsGroup.valid && this.attachmentsGroup.touched;
  }

  public get groupError(): string {
    const group = this.groupService.getFormGroup();
    return getErrorText(group);
  }

  private get attachmentsGroup(): UntypedFormGroup {
    return this.groupService.get(ATTACHMENT_NAMES.KEY) as UntypedFormGroup;
  }

  constructor(
    private groupService: AnsokanFormGroupService,
    private fb: UntypedFormBuilder,
    private router: Router,
    private supplementService: SupplementService,
  ) { }

  public ngOnInit() {
    // Create form group.
    const group = this.fb.group(SUPPLEMENT_FORM_DEF());
    // Set form group.
    this.groupService.setFormGroup(group);
    // set group validator.
    group.setValidators(CustomValidators.supplement);
    group.updateValueAndValidity({ emitEvent: false });
    // Add value subscriptions.
    this.email.valueChanges.subscribe(() => group.updateValueAndValidity({ emitEvent: false }));
    this.applicantSsn.valueChanges.subscribe(() => group.updateValueAndValidity({ emitEvent: false }));
    this.applicantText.valueChanges.subscribe(() => group.updateValueAndValidity({ emitEvent: false }));
  }

  public routeToStart(): void {
    this.router.navigate(['start']);
  }

  public onSubmit(): void {
    this.error = false;
    if (!this.formValid) {
      this.groupService.getFormGroup().markAllAsTouched();
      return;
    }
    this.submitting = true;
    // Create request.
    const request: ISupplementRequest = {
      applicantEmail: this.email.value,
      applicantSsn: this.applicantSsn.value,
      applicantText: this.applicantText.value,
      attachments: this.attachmentsGroup.get(ATTACHMENT_NAMES.ATTACHMENTS.KEY).value,
    };
    // Submit supplement request.
    this.supplementService.submitSupplement(request)
      .pipe(catchError(() => of(false)))
      .subscribe(
        () => this.handleResponse(),
        () => {
          this.submitting = false;
          this.error = true;
        },
      );

  }

  private handleResponse(): void {
    this.submitted = true;
    document.getElementById('supplement-form').hidden = true;
    setTimeout(() => this.router.navigate([APP_ROUTING_NAMES.START]), 5000);
  }

}
